import {
    Column,
    Container,
    Divider,
    EnterButton,
    Grid,
    Header,
    Label,
    Row,
    Separator,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileHistory = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const [fetching, setFetching] = useState(false);
    const [policyFetch, setPolicyFetch] = useState(false);
    const [queryFetch, setQueryFetch] = useState(false);

    const fetchingRef = useRef(fetching);
    const policyFetchRef = useRef(policyFetch);
    const queryFetchRef = useRef(queryFetch);

    // Keep refs in sync with state
    fetchingRef.current = fetching;
    policyFetchRef.current = policyFetch;
    queryFetchRef.current = queryFetch;

    const getData = () => {
        if (fetchingRef.current) {
            if (policyFetchRef.current) {
                if (props.policy) {
                    setFetching(false);
                    setPolicyFetch(false);
                }
            }
            if (queryFetchRef.current) {
                if (props.policyHistory) {
                    setFetching(false);
                    setQueryFetch(false);
                }
            }
        } else {
            if (!props.policy) {
                props.doGetPolicy();
                setFetching(true);
                setPolicyFetch(true);
            }
            if (!props.policyHistory && props.policy && props.policy.policy && props.policy.policy.guid) {
                props.doQueryPolicy();
                setFetching(true);
                setQueryFetch(true);
            }
        }
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        getData();
    });

    return (
        <Container top={sizes.sm} bottom={sizes.xl}>
            <Grid>
                <Row>
                    <Column>
                        <Container verticalAlignment={alignments.center} top={sizes.md} fullSize>
                            <Divider />
                            <Header
                                size={sizes.xl}
                                textAlign={alignments.left}
                                text={<FormattedMessage id='Profile_History.history' />}
                            />
                        </Container>
                    </Column>
                    <Column nogutter>
                        <Separator orientation='horizontal' top={sizes.sm} bottom={sizes.sm} solid />
                    </Column>
                </Row>
                {props.policyHistory?.map((policy, _i) => {
                    return (
                        <Row key={policy.guid}>
                            <Column xs={2}>
                                <Container verticalAlignment={alignments.center} top={sizes.md} fullSize>
                                    <Label textAlign={alignments.left} text={policy.product} />
                                </Container>
                            </Column>
                            <Column xs={2}>
                                <Container verticalAlignment={alignments.center} top={sizes.md} fullSize>
                                    <Label textAlign={alignments.left} text={policy.type} />
                                </Container>
                            </Column>
                            <Column xs={4} md={6}>
                                <Container verticalAlignment={alignments.center} top={sizes.md} fullSize>
                                    <Label textAlign={alignments.left} text={policy.status} />
                                </Container>
                            </Column>
                            <Column xs={4} md={2}>
                                <Container verticalAlignment={alignments.center} top={sizes.md} fullSize>
                                    <EnterButton
                                        text={<FormattedMessage id='Profile_History.go' />}
                                        clickEvent={() => {
                                            window.location = `${props.context.configuration.policyWeb}/profile?entity=${policy.guid}`;
                                        }}
                                    />
                                </Container>
                            </Column>
                        </Row>
                    );
                })}
            </Grid>
        </Container>
    );
};

export default ProfileHistory;
